// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"690":"cb121681199948ab","3443":"4ba599214aec392c","5302":"bd3e848d1a779ec0"}[chunkId] + ".css";
};